import { connect, type ConnectedProps } from 'react-redux';

import { Providers } from '~/components/utility';
import { useRouter } from '~/hooks';
import { type RootState } from '~/reducers';

const mapState = ({ nav: { location, initErrorStatus } }: RootState) => ({
  initErrorStatus,
  location,
});

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

const App = ({ initErrorStatus, location }: Props) => {
  const Component = useRouter({
    location,
    initErrorStatus,
  });

  return <Providers>{Component}</Providers>;
};

export default connector(App);
